import type React from 'react';
import { styled } from 'styled-components';

import Td from './Td.tsx';
import Tr from './Tr.tsx';

export const Wrapper = styled.div`
  display: flex;
  text-align: left;
  justify-content: flex-start;
  padding: 10px;
  word-break: break-word;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
  white-space: pre-wrap;
`;

export const Title = styled.span`
  display: inline-flex;
  white-space: nowrap;
  margin: 0 5px 0 0;
  color: ${({ theme }) => theme.colors.grey100_1};
  font-weight: 500;
  + * {
    width: 100%;
  }
`;

export interface IAdditionalRow {
  title: string;
  text?: string | React.ReactNode;
  dataTestId?: string;
  className?: string;
}

const AdditionalRow: React.FC<IAdditionalRow> = ({ title, text, dataTestId, className }) => (
  <Tr>
    <Td type='sub'>
      <Wrapper data-testid={dataTestId} className={className}>
        <Title>
          {title}
          {': '}
        </Title>
        {text}
      </Wrapper>
    </Td>
  </Tr>
);

export default AdditionalRow;
